<template>
  <footer class="auth-footer auth-text">
    Copyright &copy; 2023 <strong>{{ appName }}</strong
    >. All rights reserved - v1.1.29
    <br />
    Developed with
    <b-icon color="red" icon="heart-fill"></b-icon>
    <a
      class="text-reset fw-bold"
      href="/#"
      target="_blank"
      title="PT. Nash Interaksi Semesta"
      >PT. Nash Interaksi Semesta</a
    >
    Powered by KJS MARI
  </footer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    links: [{ name: 'Beranda', Link: '/#' }],
    appName: 'SiTrendi',
  }),
  computed: {
    ...mapGetters(['isAuthenticated', 'loggedInUser']),
  },
}
</script>

<style>
.auth-text {
  color: #bbb;
}

.auth-footer {
  margin: 20px 0;
  text-align: center;
}
</style>
